import { render, staticRenderFns } from "./homeFooter.vue?vue&type=template&id=1dfc8e34&"
import script from "./homeFooter.vue?vue&type=script&lang=js&"
export * from "./homeFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/homeFooter.vue"
export default component.exports